/**
 * @module ceilingProducts
 * @deprecated Offer-specific logic diverges from the general product spec/req engine.
 *             Do NOT import this anywhere else.
 * @todo     Refactor: extract into shared product-requirements service.
 */

/**
 * Maps symbolic formula variables (like H10) to actual product_codes
 */
export const quantityAliases = {
    H2: "203.03.37",
    H3: "302.03.01",
    H4: "302.05.01",
    H5: "302.07.01",
    H6: "302.08.01",
    H7: "302.09.01",
    H8: "302.12.01",
    H9: "302.20.01",
    H10: "302.22.01",
    H11: "502.05.12",
    H12: "505.11.44",
    H13: "601.01.54",
    H14: "1101.01.61",
    H15: "1101.02.61",
    H16: "1101.03.61",
    H17: "1101.05.24",
    H18: "1102.05.01",
    H19: "1102.13.01",
    H20: "1102.25.01",
    H21: "1102.32.01",
    H22: "1102.85.01",
    H23: "1103.01.77",
    H24: "1303.03.73",
    H25: "1401.19.77",
    H26: "1501.05.23",
    G14: "1101.01.61",
    G15: "1101.02.61",
    G16: "1101.03.61",
};
export const ceilingProducts = [
    {
        product_code: "203.03.37",
        name: "Teava Pex-Al-Pex 20x2,0 mm, cu izolatie (50m)",
        unit: "m",
        specifications: {
            percent: 4.05,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "area_m2 * pipe_density_per_m2",
                variables: ["area_m2", "pipe_density_per_m2"],
                rounding: "CEILING",
                step: 50,
                note: "Excel H2: =CEILING.XCL(G2,50)",
            },
        ],
    },
    {
        product_code: "302.03.01",
        name: "Modul racordare 1''",
        unit: "buc",
        specifications: {
            percent: 0.25,
            fixedPerFloor: true,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "2 * nr_etaje",
                variables: ["nr_etaje"],
                note: "Excel H3: =2 * nr_etaje",
            },
        ],
    },
    {
        product_code: "302.05.01",
        name: "Modul accesorii (aerisitor automat, robinet golire, termometru)",
        unit: "buc",
        specifications: {
            percent: 0.69,
            fixedPerFloor: true,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "2 * nr_etaje",
                variables: ["nr_etaje"],
                note: "Excel H4: =2 * nr_etaje",
            },
        ],
    },
    {
        product_code: "302.07.01",
        name: "Modul terminal",
        unit: "buc",
        specifications: {
            percent: 0.12,
            fixedPerFloor: true,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "2 * nr_etaje",
                variables: ["nr_etaje"],
                note: "Excel H5: =2 * nr_etaje",
            },
        ],
    },
    {
        product_code: "302.08.01",
        name: "Modul fixare dublu",
        unit: "buc",
        specifications: {
            percent: 0.11,
            fixedPerFloor: true,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "1 * nr_etaje",
                variables: ["nr_etaje"],
                note: "Excel H6: =1 * nr_etaje",
            },
        ],
    },
    {
        product_code: "302.09.01",
        name: "Modul fixare simplu",
        unit: "buc",
        specifications: {
            percent: 0.05,
            fixedPerFloor: true,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "1 * nr_etaje",
                variables: ["nr_etaje"],
                note: "Excel H7: =1 * nr_etaje",
            },
        ],
    },
    {
        product_code: "302.12.01",
        name: "Racord rapid Pex 20",
        unit: "buc",
        specifications: {
            percent: 0.67,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "4 * H10",
                variables: ["H10"],
                note: "Excel H8: =4 * H10",
            },
        ],
    },
    {
        product_code: "302.20.01",
        name: "Modul tur (dublu)",
        unit: "buc",
        specifications: {
            percent: 1.01,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "(product_total_value / unit_price) / 2",
                variables: ["product_total_value", "unit_price"],
                rounding: "CEILING",
                step: 1,
                note: "Excel H9: =CEILING.XCL(G9,1)",
            },
        ],
    },
    {
        product_code: "302.22.01",
        name: "Modul retur (dublu)",
        unit: "buc",
        specifications: {
            percent: 1.28,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "(product_total_value / unit_price) / 2",
                variables: ["product_total_value", "unit_price"],
                rounding: "CEILING",
                step: 1,
                note: "Excel H10: =CEILING.XCL(G10,1)",
            },
        ],
    },
    {
        product_code: "502.05.12",
        name: "Aditiv antialge și protecție",
        unit: "buc",
        specifications: {
            percent: 0.34,
            fixedPerFloor: false,
            fixedPerOffer: true,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "1 * 1",
                variables: [],
                note: "valoare fixă 1",
            },
        ],
    },
    {
        product_code: "505.11.44",
        name: "Cutie metalică 780x580x110 - SP4",
        unit: "buc",
        specifications: {
            percent: 1.26,
            fixedPerFloor: true,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "1 * nr_etaje",
                variables: ["nr_etaje"],
                note: "Excel H12: =1 * nr_etaje",
            },
        ],
    },
    {
        product_code: "601.01.54",
        name: "Servomotor 230 V - normal închis",
        unit: "buc",
        specifications: {
            percent: 1.65,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: true,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "2 * H10",
                variables: ["H10"],
                note: "Excel H13: =2 * H10",
            },
        ],
    },
    {
        product_code: "1101.01.61",
        name: "Panou incalzire/racire prin tavan h.42(1200x2000)",
        unit: "m²",
        specifications: {
            percent: 45.34,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "(product_total_value / unit_price)",
                variables: ["product_total_value", "unit_price"],
                rounding: "CEILING",
                step: 2.4,
                note: "Excel H14: =CEILING.XCL(G14,2.4)",
            },
        ],
    },
    {
        product_code: "1101.02.61",
        name: "Panou incalzire/racire prin tavan h.42(1200x1000)",
        unit: "m²",
        specifications: {
            percent: 12.09,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "(product_total_value / unit_price)",
                variables: ["product_total_value", "unit_price"],
                rounding: "CEILING",
                step: 1.2,
                note: "Excel H15: =CEILING.XCL(G15,1.2)",
            },
        ],
    },
    {
        product_code: "1101.03.61",
        name: "Panou incalzire/racire prin tavan h.42 (1200x500)",
        unit: "m²",
        specifications: {
            percent: 4.53,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "(product_total_value / unit_price)",
                variables: ["product_total_value", "unit_price"],
                rounding: "CEILING",
                step: 0.6,
                note: "Excel H16: =CEILING.XCL(G16, 0.6)",
            },
        ],
    },
    {
        product_code: "1101.05.24",
        name: "Panou tampon incalzire/racire prin tavan h.42 (1200x1300)",
        unit: "m²",
        specifications: {
            percent: 12.97,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "(product_total_value / unit_price)",
                variables: ["product_total_value", "unit_price"],
                rounding: "CEILING",
                step: 1.56,
                note: "Excel H17: =CEILING.XCL(G17,1.56)",
            },
        ],
    },
    {
        product_code: "1102.05.01",
        name: "Reductie simpla in linie 20x2 - 8x1 (multistrat)",
        unit: "buc",
        specifications: {
            percent: 1.63,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "(product_total_value / unit_price)",
                variables: ["product_total_value", "unit_price"],
                rounding: "ROUNDUP",
                note: "Excel H18: =ROUNDUP(G18,0)",
            },
        ],
    },
    {
        product_code: "1102.13.01",
        name: "Reductie dubla in linie 20x2 - 8x1(multistrat)",
        unit: "buc",
        specifications: {
            percent: 2.93,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "(product_total_value / unit_price)",
                variables: ["product_total_value", "unit_price"],
                rounding: "ROUNDUP",
                note: "Excel H19: =ROUNDUP(G19,0)",
            },
        ],
    },
    {
        product_code: "1102.25.01",
        name: "Reductie sipla contrapusa 20x2 - 8x1(multistrat)",
        unit: "buc",
        specifications: {
            percent: 1.4,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "(product_total_value / unit_price)",
                variables: ["product_total_value", "unit_price"],
                rounding: "ROUNDUP",
                note: "Excel H20: =ROUNDUP(G20,0)",
            },
        ],
    },
    {
        product_code: "1102.32.01",
        name: "Reductie dubla contrapusa 20x2 - 8x1(multistrat)",
        unit: "buc",
        specifications: {
            percent: 4.11,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "(product_total_value / unit_price)",
                variables: ["product_total_value", "unit_price"],
                rounding: "ROUNDUP",
                note: "Excel H21: =ROUNDUP(G21,0)",
            },
        ],
    },
    {
        product_code: "1102.85.01",
        name: "Dop 20x2",
        unit: "buc",
        specifications: {
            percent: 0.26,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: true,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "2 * H10",
                variables: ["H10"],
                note: "Excel H22: =2 * H10",
            },
        ],
    },
    {
        product_code: "1103.01.77",
        name: "Izolatie elastomer 10x6 mm (2m)",
        unit: "m",
        specifications: {
            percent: 1.38,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "4*H14/2.4 + 2*H15/1.2 + H16/0.6",
                variables: ["H14", "H15", "H16"],
                rounding: "CEILING",
                step: 2,
                note: "Excel H23: =CEILING.XCL(4*H14/2.4 + 2*H15/1.2 + H16/0.6,2)",
            },
        ],
    },
    {
        product_code: "1303.03.73",
        name: "Robinet trecere 1'' IE",
        unit: "buc",
        specifications: {
            percent: 0.56,
            fixedPerFloor: true,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "2 * floors",
                variables: ["floors"],
                note: "Excel H24: =2 * $B$31",
            },
        ],
    },
    {
        product_code: "1401.19.77",
        name: "Banda Anticondens",
        unit: "buc",
        specifications: {
            percent: 0.45,
            fixedPerFloor: false,
            fixedPerOffer: false,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "formula",
                expression: "(product_total_value / unit_price)",
                variables: ["product_total_value", "unit_price"],
                rounding: "CEILING",
                step: 1,
                note: "Excel H25: =CEILING.XCL(G25,1)",
            },
        ],
    },
    {
        product_code: "1501.05.23",
        name: "Calibrator Pex d 20x2,0mm",
        unit: "buc",
        specifications: {
            percent: 0.85,
            fixedPerFloor: false,
            fixedPerOffer: true,
            manualQty: false,
        },
        requirements: [
            {
                type: "quantity",
                method: "fixedPerOffer",
                expression: "1 * 1",
                variables: [],
                note: "valoare fixă 1",
            },
        ],
    },
];
